import styled from 'styled-components'

export const ExploreWrapper = styled.li`
  margin-bottom: 4px;
`
